import { z } from 'zod';

/**
 * Schemes safe to render into an href. http(s) for web links, mailto/tel for
 * contact links; `javascript:` and `data:` are excluded as XSS vectors.
 */
export const SAFE_URL_PROTOCOL = /^(https?|mailto|tel)$/;

const safeUrlSchema = z.url({ protocol: SAFE_URL_PROTOCOL });

/**
 * Whether `href` is a valid URL with a safe scheme. Use before turning a
 * stored value into an anchor so an unsafe scheme can't become clickable.
 */
export const isSafeHref = (href: string): boolean =>
  safeUrlSchema.safeParse(href).success;
